<template>
  <div class="content" v-loading="loading">
 
    <el-table :data="tableData">
      <el-table-column prop="created_at" label="识别时间"></el-table-column>
      <el-table-column prop="original" label="原图">
        <template slot-scope="scope">
          <span
            @click="picView(scope.row.original)"
            style="color:#1de7ff;cursor:pointer"
          >点击查看</span>
        </template>
      </el-table-column>
      <el-table-column prop="distinguish" label="识别图">
        <template slot-scope="scope">
          <span
            @click="picView(scope.row.distinguish)"
            style="color:#1de7ff;cursor:pointer"
          >点击查看</span>
        </template>
      </el-table-column>
      <el-table-column prop="license" label="识别车牌"> </el-table-column>
      <el-table-column prop="type_name" label="车牌类型"></el-table-column>
      <el-table-column prop="direction_name" label="车辆行驶方向"> </el-table-column>
      <el-table-column prop="time_used" label="识别用时（s）">
        <template slot-scope="scope">
          <span v-if="scope.row.time_used===0">少于0秒</span>
          <span v-else>{{scope.row.time_used}}秒</span>
        </template>
      </el-table-column>
      <el-table-column prop="serial_no" label="设备识别号"></el-table-column>
      <el-table-column prop="ip" label="设备IP"></el-table-column>
      <el-table-column prop="mark" label="标记">
        <template slot-scope="scope">
          <span v-if="scope.row.mark===0">正常</span>
          <span v-else style="color:#1de7ff;font-size:16px">★</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="primary" round v-if="scope.row.mark===1" @click="setMark(scope.row.id,0)">取消标记</el-button>
          <el-button type="info" round v-else @click="setMark(scope.row.id,1)">标记数据</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>


    <el-dialog
      title="车辆通过"
      class="dialog600 carPlate_box"
      :visible.sync="carInfoOneVibity"
      v-if="carInfoOneVibity"
      :before-close="closeNewOne"
    >
      <div class="img_left"><img :src="carInfoData.distinguish"></div>
      <div class="text_rgt">
        <p>识别时间：<span>{{carInfoData.created_at}}</span></p>
        <p>识别车牌：<span>{{carInfoData.license}}</span></p>
        <p>识别用时：<span>{{carInfoData.time_used}}s</span></p>
        <p>设备识别号：<span>{{carInfoData.serial_no}}</span></p>
      </div>
      <div class="clear"></div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="success"
          size="medium"
          @click="closeNewOne"
          >已查看记录</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="carInfoOneVibity = false;setMark(carInfoData.id,1)"
          >标记该记录</el-button
        >
      </div>
    </el-dialog>


    <el-image-viewer
        v-if="picData.showViewer"
        :on-close="closePic"
        :url-list="picData.picUrl" />


  </div>
</template>

<script>
import carPlatetApi from "@/api/carPlate/carPlatetApi"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      picData: {
        showViewer: false,
        picUrl: []
      },
      carInfoOneVibity: false,
      carInfoData: {
        id: null,
        serial_no: 0,
        original: "",
        distinguish: "",
        type: 1,
        direction: 0,
        created_at: "",
        time_used: 0,
        license: "",
        ip: "",
        mark: 0,
        type_name: "",
        direction_name: ""
      },
      timerNew: null
    }
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      carPlatetApi.getCarPlateListApi(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    setMark(id, value) {
      carPlatetApi.setCarinfoMark(id,{ mark: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("操作成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closePic() {
      this.picData.showViewer = false
      this.picData.picUrl = []
    },
    picView(url) {
      this.picData.picUrl[0] = url
      this.picData.showViewer = true
    },
    aiNewOne() {
      carPlatetApi.getCarPlateNewApi().then((res) => {
        if (res.data.code === 1000) {
          let resData =res.data.data
          if(!this.carInfoOneVibity){
            if(resData.length>0){
              this.carInfoOneVibity = true
              this.carInfoData = res.data.data[0];
            }
          }
        }
      });
    },
    closeNewOne() {
      this.getTableData(this.pageInfo.page);
      this.carInfoOneVibity = false
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
    this.aiNewOne()
    if (this.timerNew) {
      clearInterval(this.timerNew)
    } else {
      this.timerNew = setInterval(() => {
        setTimeout(this.aiNewOne(), 0)
      }, 6 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timerNew)
    this.timerNew = null
  }
};
</script>

<style lang='less' scoped>
.carPlate_box{
  .img_left{
    width:280px;float:left;
    img{
      max-width: 100%;
    }
  }
  .text_rgt{
    width:250px;float:right;
    p{
      margin:0;
      color:#666;
      line-height: 24px;
      span{
        color:#333;
        margin-left: 5px;
      }
    }
  }
}

</style>
